import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { BookOpen, User, Lightbulb } from 'lucide-react';

const FragmentosView = ({ fragmentos }) => {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Biblioteca de Clásicos</h2>
        <p className="text-gray-600">Aprende de los maestros de la literatura</p>
      </div>
      
      {fragmentos.length === 0 ? (
        <Card>
          <CardContent className="text-center py-8">
            <BookOpen className="h-16 w-16 mx-auto text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Cargando fragmentos...</h3>
            <p className="text-gray-600">Estamos preparando los mejores ejemplos de la literatura</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-2">
          {fragmentos.map((fragmento) => (
            <Card key={fragmento.id} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex justify-between items-start">
                  <div>
                    <CardTitle className="text-lg text-amber-900">{fragmento.titulo}</CardTitle>
                    <CardDescription className="flex items-center gap-2 mt-1">
                      <User className="h-4 w-4" />
                      {fragmento.autor} • {fragmento.obra}
                    </CardDescription>
                  </div>
                  <Badge variant="secondary" className="bg-amber-100 text-amber-800">
                    Clásico
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Fragmento */}
                <div>
                  <h4 className="font-medium text-gray-900 mb-2">Fragmento:</h4>
                  <blockquote className="border-l-4 border-amber-300 pl-4 py-2 bg-amber-50 italic text-gray-700">
                    "{fragmento.fragmento}"
                  </blockquote>
                </div>
                
                {/* Análisis */}
                <div>
                  <h4 className="font-medium text-gray-900 mb-2 flex items-center gap-2">
                    <Lightbulb className="h-4 w-4 text-yellow-500" />
                    Análisis:
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {fragmento.analisis}
                  </p>
                </div>
                
                {/* Lección */}
                <div className="bg-blue-50 p-3 rounded-lg">
                  <h4 className="font-medium text-blue-900 mb-1">💡 Lección clave:</h4>
                  <p className="text-blue-800 text-sm font-medium">
                    {fragmento.leccion}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default FragmentosView;